import "./App.css";
import "@/common/i18n/i18n";
import "@/styles/globals.scss";
import { updateAppConfig } from "./common/config/appConfig";
import configLoader from "./common/config/configLoader";
import AdvisorCodeInfoProvider from "./common/context/advisorCodeInfoProvider";
import ApplicationInfoProvider from "./common/context/ApplicationInfoProvider";
import CallToActionProvider from "./common/context/callToActionProvider";
import { FormContextProvider } from "./common/context/formContextProvider";
import LanguageProvider from "./common/context/languageProvider";
import ProductInfoProvider from "./common/context/productInfoProvider";
import TranslationProvider from "./common/context/TranslationProvider";
import { IdleTimeoutDialog, PageLayout } from "./components/shared";
import { AppRoutes } from "./routes";
import { DialogProvider } from "@/common/context/DialogProvider";
import { ThemeProvider } from "@emotion/react";
import { theme } from "@equitable/equx";
import { useEffect, useState } from "react";

function App() {
  const [showApp, setShowApp] = useState(false);

  useEffect(() => {
    configLoader().then((config) => {
      updateAppConfig(config);
      setShowApp(true);
    });
  }, []);

  return (
    <>
      {showApp && (
        <>
          <LanguageProvider>
            <TranslationProvider>
              <ApplicationInfoProvider>
                <CallToActionProvider>
                  <ThemeProvider theme={theme}>
                    <FormContextProvider>
                      <ProductInfoProvider>
                        <AdvisorCodeInfoProvider>
                          <DialogProvider>
                            <PageLayout>
                              <AppRoutes />
                            </PageLayout>
                          </DialogProvider>
                        </AdvisorCodeInfoProvider>
                      </ProductInfoProvider>
                    </FormContextProvider>
                  </ThemeProvider>
                </CallToActionProvider>
              </ApplicationInfoProvider>
            </TranslationProvider>
          </LanguageProvider>
        </>
      )}
      <IdleTimeoutDialog />
    </>
  );
}

export default App;
